/*
 * @description:
 * @author: Jason Wong
 * @since: 2021-12-27 15:33:45
 */
export default {
  state: {
    fileName: "-",
    readonly: false,
    readonlyMessage: null,
  },
  mutations: {
    setCatFileName(state, data) {
      state.fileName = data;
    },
    setReadonlyInfo(state,data){
      state.readonly = data.readonly;
      state.readonlyMessage = data.readonlyMessage;
    }
  },
  actions: {
    setCatFileName({ commit }, data) {
      commit("setCatFileName", data);
    },
    setReadonlyInfo({commit},data){
      commit('setReadonlyInfo',data);
    }
  },
  getters: {
    catFileName(state) {
      return state.fileName;
    },
    catReadonly(state) {
      return state.readonly;
    },
    catReadonlyMessage(state) {
      return state.readonlyMessage;
    }
  },
};
